class mediaGallery extends HTMLElement {
    constructor (){
        super()
        this.initThumbsSlider()
        this.initMainSlider()
    }
    initMainSlider(){
        this.mainSlider = new Swiper(".main-slider", {
            slidesPerView: 1,
            navigation: {
                nextEl: "[data-button-next]",
                prevEl: "[data-button-prev]",
            },
            thumbs: {
                swiper: this.thumbsSLider,
            },
        });
    }
    initThumbsSlider(){
        this.thumbsSLider = new Swiper('.thumbs-slider', {
            slidesPerView: 'auto',
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
                0: {
                    direction: 'horizontal',
                    spaceBetween: 4,
                    slidesOffsetBefore: 16
                },
                990: {
                    direction: 'vertical',
                    spaceBetween: 4,
                    slidesOffsetBefore: 0
                }
            }
        });
    }
}

window.customElements.define('sc-product-gallery', mediaGallery);
